import React from 'react';
import { Link } from 'react-router-dom';
import { Layout, Menu, Result, Button } from 'antd';
import { useParams } from 'react-router-dom';
import adminRouteConfig from './adminRouteConfig';
import Navigation from './pages/shared/Navigation';
import '../styles/third-party/antd/antd.css';
import './styles/index.scss';

const { SubMenu } = Menu;
const { Header, Content, Sider } = Layout;

export default Admin = props => {
    let content = props.children;

    return (
        <Layout id="adaya-admin">

            {/* <ErrorBoundary> */}

            <Navigation />

            <Layout>
                <Content className="admin-page-wrapper">
                    {content}
                </Content>
            </Layout>

            {/* </ErrorBoundary> */}

        </Layout>);
};